import { observer } from "mobx-react";
import React from "react";
import { AppStore } from "../../stores/AppStore";
import { Alignment, Button, Classes, Dialog, FormGroup, InputGroup, MenuItem, NumericInput, Switch, Tag } from "@blueprintjs/core";
import { BootstrapTable, TableHeaderColumn, } from "react-bootstrap-table";
import moment from "moment";
import { MDBCol, MDBRow } from "mdbreact";
import { Pager } from "../utils/Pager";
import { observable } from "mobx";
import { debounce } from "underscore";
import { toast } from "react-toastify";
import { StatusStore } from "../../stores/status/StatusStore";
import { Suggest } from "@blueprintjs/select";
import { TipoSelect, filterItens, renderItens } from "../utils/TipoSelect";
import ReactJson from "react-json-view";

interface Props { }

interface State { }

@observer
export class StatusPage extends React.Component<Props, State> {

  obs = observable({
    fetchOptions: {} as any,

    open_create: false as boolean,
    loading_save: false as boolean,
    status: "" as string,
    nome: "" as string,
    color: "" as string,
    tipo: "" as string,
    alias: "" as string,
    aplicar_todos: false as boolean,
    open_erros: false as boolean,
    erros: [] as any,

    filter_status: "" as string,
    filter_nome: "" as string,
    filter_tipo: {} as { cod: string, descricao: string },

    status_current: 1
  })

  constructor(props) {
    super(props);

    AppStore.setTitle("Status das Tarefas");

    this.obs.fetchOptions = debounce(this.handleStatus.bind(this), 800);

  }

  componentDidMount(): void {

    this.obs.status_current = 1

    this.obs.filter_status = ""
    this.obs.filter_nome = ""
    this.obs.filter_tipo = { cod: "", descricao: "TODOS" }

    this.handleStatus()

  }

  async handleStatus() {

    await StatusStore.handleStatus(
      this.obs.status_current,
      this.obs.filter_status,
      this.obs.filter_nome,
      this.obs.filter_tipo.cod
    )

  }

  formaterDate = (cell, row) => {

    if (!cell) return ""

    return (
      <span style={{ fontSize: 10 }}>{moment(cell).format("DD/MM/YYYY")}</span>
    )

  };

  formaterTipo = (cell, row) => {

    if (!cell) return "N/A"

    return (
      <span style={{ fontSize: 10 }}>{cell.toUpperCase()}</span>
    )

  };

  formaterLocator = (cell, row) => {

    if (cell == null) return ""

    return (
      <span style={{ fontSize: 10 }}>{cell}</span>
    )

  }

  formaterColor = (cell, row) => {

    if (cell == null) return ""

    return (<div style={{ display: "flex", gap: 10 }}>
      <div
        key={cell}
        title={cell}
        style={{
          width: 20,
          height: 20,
          background: cell,
          borderRadius: 4,
        }}
      />
      <span style={{ fontSize: 10 }}>{cell}</span>
    </div>)

  };

  formaterStatus = (cell, row) => {

    return (<Tag className={`tagConfirmacao`} style={{ background: row.color, borderColor: row.color, color: "#fff", width: "100%", textAlign: "center" }}>{row.nome}</Tag>)

  };

  handleBuscaFiltered(filtro: string) {

    this.obs.status_current = 1
    this.obs.filter_nome = filtro

    this.obs.fetchOptions()

  }

  handleChangeFilterStatus = (valueAsNumber: number, valueAsString: string) => {

    this.obs.filter_status = valueAsString.replace(/\D/g, "")

    this.obs.fetchOptions()

  }

  async handleChangePage(page: number) {

    this.obs.status_current = page

    await StatusStore.handleStatus(
      page,
      this.obs.filter_status,
      this.obs.filter_nome,
      this.obs.filter_tipo.cod
    )

  }

  handleOpenCreate() {

    this.obs.status = ""
    this.obs.nome = ""
    this.obs.tipo = ""
    this.obs.alias = ""
    this.obs.color = ""

    this.obs.aplicar_todos = false

    this.obs.open_create = true

  }

  onClose() {

    this.obs.open_create = false

  }

  async handleSave(listaUnicaTipos) {

    if (!this.obs.nome) {
      toast.warn("Favor preencha o campo Nome.", {})
      return
    }

    if (this.obs.status === "" || this.obs.status === null) {
      toast.warn("Favor preencha o campo Status.", {})
      return
    }

    if (!this.obs.aplicar_todos && !this.obs.tipo) {
      toast.warn("Favor preencha o campo Tipo.", {})
      return
    }

    if (!this.obs.aplicar_todos && !this.obs.alias) {
      toast.warn("Favor preencha o campo Alias.", {})
      return
    }

    this.obs.open_create = false
    this.obs.loading_save = true

    const registros = this.obs.aplicar_todos
      ? listaUnicaTipos.map((item) => ({
        tipo: item.tipo,
        alias: item.alias,
      }))
      :
      [{
        tipo: this.obs.tipo,
        alias: this.obs.alias,
      }];

    const data = {
      status: parseInt(this.obs.status),
      nome: this.obs.nome,
      color: (this.obs.color || null),
      registros
    }

    const res = await StatusStore.handleCreateStatus(data)

    await StatusStore.handleStatus(
      this.obs.status_current,
      this.obs.filter_status,
      this.obs.filter_nome,
      this.obs.filter_tipo.cod
    )

    await StatusStore.handleStatusAll()

    this.obs.loading_save = false

    if (!res) {

      toast.error('Erro ao cadastrar status, tente novamente mais tarde.', {});

    } else if (!res.length) {

      toast.success('Status cadastrados com sucesso.', {});

    } else {

      this.obs.open_erros = true
      this.obs.erros = res

    }

  }

  async handleChangeAtivo(row: any, checked: boolean) {

    const data = {
      id: row._id,
      nome: row.nome,
      status: parseInt(row.status),
      color: (row.color || null),
      tipo: row.tipo,
      alias: row.alias,
      ativo: checked
    }

    await StatusStore.handleUpdateStatus(data)

    await StatusStore.handleStatus(
      this.obs.status_current,
      this.obs.filter_status,
      this.obs.filter_nome,
      this.obs.filter_tipo.cod
    )

    await StatusStore.handleStatusAll()

  }

  formaterDetalhes = (cell, row) => {
    return (
      <>
        <Switch
          className="switch-status-tarefa"
          label={row.ativo ? "Ativado" : "Desativado"}
          checked={row.ativo}
          onChange={(e: any) => this.handleChangeAtivo(row, e.target.checked)}
        />
      </>
    )
  }

  onAfterSaveCell = async (row, cellName, cellValue) => {

    if (!row.nome) {
      toast.warn("Campo Nome não pode ficar em branco.", {})
      this.handleStatus()
      return
    }

    if (row.status === "" || row.status === null) {
      toast.warn("Favor preencha o campo Status.", {})
      this.handleStatus()
      return
    }

    if (!row.tipo) {
      toast.warn("Favor preencha o campo Tipo.", {})
      return
    }

    if (!row.alias) {
      toast.warn("Favor preencha o campo Alias.", {})
      return
    }

    const data = {
      id: row._id,
      nome: row.nome,
      status: parseInt(row.status),
      color: (row.color || null),
      tipo: row.tipo,
      alias: row.alias,
      ativo: (row.ativo || false)
    }

    await StatusStore.handleUpdateStatus(data)

    await StatusStore.handleStatus(
      this.obs.status_current,
      this.obs.filter_status,
      this.obs.filter_nome,
      this.obs.filter_tipo.cod
    )

    await StatusStore.handleStatusAll()

  }

  handleChangeStatus = (valueAsNumber: number, valueAsString: string) => {

    this.obs.status = valueAsString.replace(/\D/g, "")

  };

  handleChangeTipo(e: { cod: string, descricao: string }) {

    this.obs.filter_tipo = e

    this.handleChangePage(1)

  }

  render() {

    const textEdit = {
      type: "input",
    }

    const cellEditProp = {
      mode: 'dbclick',
      blurToSave: true,
      afterSaveCell: this.onAfterSaveCell
    };

    const colors = StatusStore.obs.status_all.map(x => x.color)

    const conjunto = new Set(colors);

    const listaElementosUnicos = Array.from(conjunto);

    const listaUnicaTipos = [
      ...new Map(StatusStore.obs.status_all.map(item => [item.tipo, item])).values()
    ];

    let tipoTarefaText = this.obs.filter_tipo.cod ? `${this.obs.filter_tipo.descricao}` : "TODOS";

    return (

      <>

        <MDBRow style={{ marginBottom: 10 }}>

          <MDBCol md="2">
            <FormGroup className="form-group" label="Status">
              <NumericInput
                className="input-numeric"
                value={this.obs.filter_status}
                onValueChange={this.handleChangeFilterStatus}
                buttonPosition="none"
                placeholder="Exemplo: 1"
                min={0}
                minorStepSize={null}
                allowNumericCharactersOnly
              />
            </FormGroup>
          </MDBCol>

          <MDBCol md="3">
            <FormGroup className="form-group" label="Nome">
              <InputGroup
                round
                style={{ borderRadius: 10 }}
                placeholder="Exemplo: NOVA SOLICITAÇÃO"
                value={this.obs.filter_nome}
                onChange={(e: any) => this.handleBuscaFiltered(e.target.value)}
              />
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <FormGroup className="form-group empresaSelect selectValues" label="Tipo da Tarefa">
              <TipoSelect
                items={
                  [
                    { cod: "", descricao: "TODOS" },
                    ...listaUnicaTipos.map(x => ({
                      cod: x.tipo,
                      descricao: x.alias.toUpperCase()
                    }))
                  ]
                }
                itemRenderer={renderItens}
                itemPredicate={filterItens}
                onItemSelect={(e) => this.handleChangeTipo(e)}
                matchTargetWidth={true}
                inputProps={{ placeholder: "Filtrar um Tipo" }}
              >
                <Button
                  className="tipo-select-bots"
                  text={tipoTarefaText}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                />
              </TipoSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol>
            <Button
              style={{ marginTop: 28 }}
              text="Criar Status"
              className="btnDefault btnBuscarNfe btnVerde"
              onClick={() => this.handleOpenCreate()}
            />
          </MDBCol>

        </MDBRow>

        <BootstrapTable className="TabelaSimples" data={StatusStore.obs.status} cellEdit={cellEditProp}>
          <TableHeaderColumn dataField="id" width="1%" isKey={true} hidden >#</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterLocator} dataField="status" editable={textEdit} width="5%">Status</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterLocator} dataField="nome" editable={textEdit} width="15%">Nome</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterColor} dataField="color" editable={textEdit} width="10%">Cor</TableHeaderColumn>
          <TableHeaderColumn dataField="tipo" editable={textEdit} width="15%">Tipo da Tarefa</TableHeaderColumn>
          <TableHeaderColumn dataField="alias" editable={textEdit} width="15%">Alias</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterStatus} editable={false} width="15%">Pré-visualização</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterDate} editable={false} dataAlign="center" dataField="inserted_at" width="10%">Criado em</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterDetalhes} editable={false} width="10%"></TableHeaderColumn>
        </BootstrapTable>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.status_current}
            totalCount={StatusStore.obs.status_length}
            pageSize={15}
            onPageChange={(page) => this.handleChangePage(page)}
          />
        </div>

        <div style={{ marginBottom: 120 }} />

        <Dialog isOpen={this.obs.open_create} className="AlertUser modalSefa modalAjusteSped">
          <h2 className="titleSEFAZ modal-sefa">Novo Status</h2>

          <div style={{ display: "flex", gap: 5 }}>
            <FormGroup className="form-group" label="Status" labelInfo="*">
              <NumericInput
                className="input-numeric"
                value={this.obs.status}
                onValueChange={this.handleChangeStatus}
                buttonPosition="none"
                placeholder="Exemplo: 1"
                style={{ width: 200 }}
                min={0}
                minorStepSize={null}
                allowNumericCharactersOnly
              />
            </FormGroup>

            <FormGroup className="form-group" label="Nome" labelInfo="*" style={{ width: "100%" }}>
              <InputGroup type="text" onChange={(e) => this.obs.nome = e.target.value} value={this.obs.nome} placeholder="Exemplo: PROCESSANDO" />
            </FormGroup>

          </div>

          <Switch
            checked={this.obs.aplicar_todos}
            label="Criar este status para todos os tipos de tarefa"
            onChange={(event: any) => {
              this.obs.aplicar_todos = event.target.checked;
            }}
          />

          {!this.obs.aplicar_todos && (
            <div style={{ display: "flex", gap: 5 }}>

              <FormGroup
                className="form-group"
                label="Tipo da Tarefa"
                labelInfo="*"
                style={{ width: "50%" }}
              >
                <Suggest
                  items={listaUnicaTipos}
                  selectedItem={null}
                  query={this.obs.tipo || ""}
                  resetOnClose={false}
                  resetOnSelect={false}
                  closeOnSelect={true}
                  onQueryChange={(query) => {
                    this.obs.tipo = query;
                  }}
                  onItemSelect={(item) => {
                    this.obs.tipo = item.tipo;
                  }}
                  itemPredicate={(query, item) => {
                    const busca = query.toLowerCase();
                    return (item.tipo.toLowerCase().includes(busca) || item.alias.toLowerCase().includes(busca));
                  }}
                  itemRenderer={(item, { handleClick, modifiers }) => {
                    if (!modifiers.matchesPredicate) return null;
                    return (
                      <MenuItem
                        key={item.tipo}
                        active={modifiers.active}
                        onClick={handleClick}
                        text={item.tipo}
                        label={item.alias}
                      />
                    );
                  }}
                  inputValueRenderer={() => this.obs.tipo}
                  inputProps={{ fill: true, placeholder: "Exemplo: solicitacao_sefa" }}
                  noResults={<MenuItem disabled text={this.obs.tipo ? `Usar "${this.obs.tipo}"` : "Digite um tipo"} />}
                  popoverProps={{ minimal: true }}
                />
              </FormGroup>

              <FormGroup
                className="form-group"
                label="Alias"
                labelInfo="*"
                style={{ width: "50%" }}
              >
                <Suggest
                  items={listaUnicaTipos}
                  selectedItem={null}
                  query={this.obs.alias || ""}
                  resetOnClose={false}
                  resetOnSelect={false}
                  closeOnSelect={true}
                  onQueryChange={(query) => {
                    this.obs.alias = query;
                  }}
                  onItemSelect={(item) => {
                    this.obs.alias = item.alias;
                  }}
                  itemPredicate={(query, item) => {
                    const busca = query.toLowerCase();
                    return (item.alias.toLowerCase().includes(busca) || item.tipo.toLowerCase().includes(busca));
                  }}
                  itemRenderer={(item, { handleClick, modifiers }) => {
                    if (!modifiers.matchesPredicate) return null;
                    return (
                      <MenuItem
                        key={item.alias}
                        active={modifiers.active}
                        onClick={handleClick}
                        text={item.alias}
                        label={item.tipo}
                      />
                    );
                  }}
                  inputValueRenderer={() => this.obs.alias}
                  inputProps={{ fill: true, placeholder: "Exemplo: SOLICITAÇÕES SEFA" }}
                  noResults={<MenuItem disabled text={this.obs.alias ? `Usar "${this.obs.alias}"` : "Digite um alias"} />}
                  popoverProps={{ minimal: true }}
                />
              </FormGroup>

            </div>
          )}

          <div style={{ display: "flex", gap: 5 }}>

            <FormGroup style={{ width: "20%" }} label="Cor">
              <InputGroup
                value={this.obs.color}
                onChange={e => (this.obs.color = e.target.value)}
                placeholder="#166470"
                className="color-input"
                rightElement={
                  <input
                    type="color"
                    value={this.obs.color || "#166470"}
                    onChange={e => (this.obs.color = e.target.value)}
                    style={{
                      width: 30,
                      height: 30,
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                    }}
                  />
                }
              />
            </FormGroup>

            <FormGroup className="form-group" label="Cores cadastradas" style={{ width: "80%" }}>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", borderRadius: 10, border: "1px solid rgba(27, 99, 111, 0.5)", padding: 10 }}>
                {listaElementosUnicos.map(color => (
                  <div
                    key={color}
                    title={color}
                    onClick={() => this.obs.color = color}
                    style={{
                      width: 20,
                      height: 20,
                      background: color,
                      borderRadius: 4,
                      cursor: "pointer",
                    }}
                  />
                ))}
              </div>
            </FormGroup>

          </div>

          {this.obs.nome &&
            <div style={{ width: "100%", textAlign: "center", border: "1px solid rgba(27, 99, 111, 0.5)", padding: 5, borderRadius: 10, marginBottom: 10 }}>
              <p><b>Pré-visualização</b></p>
              <Tag className={`tagConfirmacao`} style={{ background: this.obs.color, borderColor: this.obs.color, color: "#fff", width: "50%", textAlign: "center" }}>{this.obs.nome}</Tag>
            </div>
          }

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.onClose()} />
            <Button text="Salvar" intent="primary" onClick={() => this.handleSave(listaUnicaTipos)} disabled={this.obs.loading_save} loading={this.obs.loading_save} />
          </div>

        </Dialog>

        <Dialog
          usePortal={true} isOpen={this.obs.open_erros} onClose={() => {this.obs.open_erros = false; this.obs.erros = [];}} className="alertErros">
          <h2 className="titleSEFAZ">Erros ocorridos durante o Cadastro</h2>

          <div style={{ height: 400, overflow: "auto", marginBottom: 15 }}>
            <ReactJson
              collapsed={false}
              displayDataTypes={false}
              src={this.obs.erros}
            />
          </div>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" intent="primary" onClick={() => {this.obs.open_erros = false; this.obs.erros = [];}} />
          </div>
        </Dialog>

      </>

    );

  }

}
